import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: `fz-game-card-prize-description, [fz-game-card-prize-description], [fzGameCardPrizeDescription]`,
  templateUrl: './prize-description.component.html',
  styleUrls: ['./prize-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameCardPrizeDescriptionComponent {
  @Input()
  title?: string;

  @Input()
  content?: string;

  @Input()
  imgUrl?: string;
}
